import { Theme } from '@lumapps/lumx/react';

export const calculateThemeColor = (theme: string = Theme.light) => {
    return theme !== Theme.light ? 'light' : 'dark';
};
